import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appCtaBtn]'
})
export class CtaBtnDirective implements OnInit {
    ctaButtonStyles = {
        'background': '#012169',
        'border-color': '#012169',
        'outline': '#012169',
        'color': '#ffffff',
        'font-size': '16px',
        'line-height': '26px',
        'border-radius': '6.5px',
        'padding': '14px 26px 12px'
    }

    constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    }

    ngOnInit(): void {
        this.renderer.addClass(this.elementRef.nativeElement, 'btn');
        this.renderer.addClass(this.elementRef.nativeElement, 'btn-primary');
        this.renderer.addClass(this.elementRef.nativeElement, 'px-4');
    }

}
